module.exports = __webpack_public_path__ + "/bundle/asset/im-2-29438b2edde78dc2d2a7d73bf72039b4.png";